import { render, staticRenderFns } from "./ClientProfilePaymentMethods.vue?vue&type=template&id=0c5fce2b&"
import script from "./ClientProfilePaymentMethods.vue?vue&type=script&lang=js&"
export * from "./ClientProfilePaymentMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports